export const Timezone = {
  "America/Los_Angeles": "America/Los_Angeles",
  "America/Chicago": "America/Chicago",
  "America/New_York": "America/New_York",
  "Europe/London": "Europe/London",
  UTC: "UTC",
  "Asia/Tokyo": "Asia/Tokyo",
  "Australia/Sydney": "Australia/Sydney",
} as const;
